import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var FireColor = function FireColor(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FireColor_svg__FireColor_svg__clip0_18188_91064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27 5.852s.474.697 1.468 1.286c0 0-.72-6.082 3.97-7.138C5.505 4.41 8.234 5.653 9.23 3.323c1.662 2.218.4 4.154.4 4.154.682.098 1.254-.646 1.254-.646a4.892 4.892 0 11-9.614-.978z",
    fill: "#FF6536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.884 6.83s-.572.745-1.253.647c0 0 1.261-1.936-.4-4.154C8.236 5.653 5.506 4.41 6.708 0A5.26 5.26 0 006 .211V12a4.892 4.892 0 004.884-5.17z",
    fill: "#FF421D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.854 9.855a2.146 2.146 0 103.579-1.597c-.83 1.127-2.012-.583-1.09-1.831 0 0-2.489.312-2.489 3.428z",
    fill: "#FBBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.146 9.855a2.14 2.14 0 00-.713-1.597c-.83 1.127-2.012-.583-1.09-1.831 0 0-.136.017-.343.082V12c1.185 0 2.146-.96 2.146-2.145z",
    fill: "#FFA900"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FireColor_svg__FireColor_svg__clip0_18188_91064"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  }))));
};
export default FireColor;